import "../Stylesheet/HomeProject.css";
import { FaGithub } from "react-icons/fa";
import { FiExternalLink } from "react-icons/fi";
import image1 from "../Assets/Image1.png";
import image2 from "../Assets/Image2.png";
import image4 from "../Assets/Container.png";
import image5 from "../Assets/Image4.png";
import image6 from "../Assets/Image5.png";
import image7 from "../Assets/Image6.png";
import { useContext } from "react";
import { LanguageContext } from "../Context/LanguageContext";

export default function HomeProject() {

    const { t ,lang } = useContext(LanguageContext);
    const data = t.projects;
    const images = [image2, image1, image5, image7, image6, image4];

    return (
        <section className="featured">
            <div className="featured-wrapper">

                {/* HEADER */}
                <div className="featured-header">
                    <h2 className={lang === "ta" ? "h2-tam" : "h2-eng"}>{data.title}</h2>
                    <p>{data.subtitle}</p>
                </div>

                <div className="projects-grid">
                    {data.items.map((project, index) => (
                        <div className="project-card" key={index}>

                            {/* image-container */}

                            <div className="project-image">
                                <span className="project-badge">{project.badge}</span>
                                <img src={images[index]} alt={project.title} />

                                <div className="project-overlay">
                                    <div className="overlay-icon"><FaGithub /></div>
                                    <div className="overlay-icon"><FiExternalLink /></div>
                                </div>
                            </div>

                            {/* body-container */}

                            <div className="project-body">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>

                                <div className="tech-stack">
                                    {project.tech.map((t, i) => (
                                        <span key={i}>{t}</span>
                                    ))}
                                </div>

                                <button className="details-btn">{data.button}</button>
                            </div>

                        </div>
                    ))}</div>

            </div>
        </section>
    )
}
